import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import Helmet from "react-helmet";
import { toast } from "react-toastify";
import logoPague from "../assets/logo-azulescura.png";
import { useGeneral } from "../contexts/GeneralInfoContext";
import { Api } from "../services/Api";

function QuickMenu({ handleSwitch, selected }) {
  const [loading, setLoading] = useState(false);
  //Show Menu de acesso rapido login
  const [showMenu, setShowMenu] = useState(false);
  const [showMktzap, setShowMktzap] = useState(false);
  const [showSegundaVia, setShowSegundaVia] = useState(false);
  const [showSelectCredor, setShowSelectCredor] = useState(false);
  const [showChatOnline, setShowChatOnline] = useState(true);

  const [email, setEmail] = useState("");
  const [credorData, setCredorData] = useState("");
  const [, setCredorDocumento] = useState("");
  const { mostrarLogo } = useGeneral();

  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener, noreferrer");
    if (newWindow) newWindow.opener = null;
  };
  const segundaVia = async (event) => {
    event.preventDefault();
    const DocumentData = email;
    setLoading(true);
    try {
      const { data } = await Api.get(`botwpp/listarCredores/${DocumentData}`);
      // console.log(data)
      // return data
      setCredorData(data);
      setShowSelectCredor(true);
    } catch (error) {
      console.error(error);
      if (error.response === undefined) return toast.error("Erro de conexão com o servidor!");
      if (error.response.status === 500) return toast.error("Erro de conexão com o servidor!");
      if (error.response.status === 401)
        return toast.error("Cliente não encontrado com essa combinação de documento e data");
      if (error.response.status === 404)
        return toast.error("Não encontramos seu E-mail no nosso sistema. Entre em contato com nosso suporte.");
    } finally {
      setLoading(false);
    }
  };

  const segundaViaEnviar = async (event) => {
    event.preventDefault();
    setLoading(true);
    setShowSegundaVia(false);
    setShowSelectCredor(false);
    setEmail("");
    setCredorData("");
    setCredorDocumento("");
    toast.success("Enviando Segunda Via para seu E-mail, em breve você receberar na sua caixa de mensagem.");
    try {
      //console.log(data)
      toast.success("E-mail enviado com sucesso");
    } catch (error) {
      console.error(error);
      if (error.response === undefined) return toast.error("Erro de conexão com o servidor!");
      if (error.response.status === 500) return toast.error("Erro de conexão com o servidor!");
      if (error.response.status === 401)
        return toast.error("Cliente não encontrado com essa combinação de documento e data");
      if (error.response.status === 404)
        return toast.error("Não encontramos seu E-mail no nosso sistema. Entre em contato com nosso suporte.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className="
                         hover:cursor-pointer 
                         grid content-center justify-items-center 
                         w-[8vh] h-[8vh]
                         absolute bottom-10 right-4 sm:bottom-16 sm:right-6 md:bottom-7 md:right-4
                         text-neutral-50 z-10
                         "
        style={{
          backgroundColor: "#111F77",
          borderRadius: 50,
          borderColor: "white",
          borderWidth: "0.4vh",
        }}
        onClick={() => {
          setShowMenu(true);
          handleSwitch(true);
        }}
      >
        <i className="pi pi-align-justify" style={{ fontSize: "2.2vh" }}></i>

        <p className="text-[1.7vh]">Menu</p>
      </div>
      {showMenu && (
        <Dialog
          className="w-[80%] sm:w-[60%] md:w-[50%] lg:w-[40%] xl:w-[35%] 
                         h-auto popup-persistente-login"
          visible
          header={
            mostrarLogo && (
              <img
                className="mx-2"
                src={logoPague}
                alt="direto-logo"
                style={{ minHeight: "30px", maxHeight: "20px", width: "auto" }}
              />
            )
          }
          footer={true}
          onHide={() => {
            setShowMenu(false);
            handleSwitch(false);
          }}
        >
          <h5 className="text-center">
            <b>Bem vindo ao menu de acesso rápido.</b>
          </h5>
          <h6 className="text-center">
            <b>Selecione em que posso lhe ajudar.</b>
          </h6>
          <div className="grid w-full h-full md:text-left text-center justify-evenly">
            {selected !== false && false && (
              <div
                className="
                        hover:cursor-pointer 
                        flex
                        px-3
                        py-1
                        mt-3
                        ml-5
                        "
                onClick={() => setShowSegundaVia(true)}
                style={{
                  backgroundColor: "#1077df",
                  borderRadius: 15,
                  borderColor: "white",
                }}
              >
                <div className="flex text-base text-yellow-50">
                  <i className="pi pi-file mr-3" style={{ fontSize: "1.4em" }}></i>
                  <h6 className="font-lato text-sm self-center">Segunda Via do Boleto</h6>
                </div>
              </div>
            )}

            {showChatOnline && (
              <div
                className="
                        hover:cursor-pointer 
                        flex
                        mt-2 ml-5
                        px-3
                        py-1
                        "
                onClick={() => {
                  setShowMktzap(true);
                  setShowChatOnline(false);
                  toast.success("Clique na barra abaixo para abrir o chat. ▼ ▼ ▼ ▼ ▼ ▼ ", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    className: "foo-bar bottom-12 sm:bottom-5",
                  });
                }}
                style={{
                  backgroundColor: "#25D366",
                  borderRadius: 15,
                  borderColor: "white",
                }}
              >
                <div className="flex text-base text-yellow-50">
                  <i className="pi pi-users mr-3" style={{ fontSize: "1.4em" }}></i>
                  <h6 className="font-lato text-sm self-center">Chat Online</h6>
                </div>
              </div>
            )}
            <div
              className="
                        hover:cursor-pointer 
                        flex
                        mt-2 ml-5
                        mb-2
                        px-3
                        py-1
                        "
              onClick={() => openInNewTab("https://wa.me/5511996383405?text=Oi")}
              style={{ backgroundColor: "#25D366", borderRadius: 15, borderColor: "white" }}
            >
              <div className="flex text-base text-yellow-50">
                <i className="pi pi-whatsapp mr-3" style={{ fontSize: "1.4em" }}></i>
                <h6 className="font-lato text-sm self-center">Whatsapp 1</h6>
              </div>
              {/* </a> */}
            </div>
            <div
              className="
                        hover:cursor-pointer 
                        flex
                        mt-2 ml-5
                        px-3
                        py-1
                        "
              onClick={() => openInNewTab("https://wa.me/5511988812431?text=Oi")}
              style={{ backgroundColor: "#25D366", borderRadius: 15, borderColor: "white" }}
            >
              <div className="flex text-base text-yellow-50">
                <i className="pi pi-whatsapp mr-3" style={{ fontSize: "1.4em" }}></i>
                <h6 className="font-lato text-sm self-center">Whatsapp 2</h6>
              </div>
              {/* </a> */}
            </div>
            {/* <div className='flex w-auto h-auto text-center justify-center my-3'>
                                   <p className='text-xs '>ou ligue através de</p>
                                   <p className='text-xs ml-1'><b>(11) 9 4569-5915</b></p>
                                   <p className='text-xs'>.</p>
                              </div> */}
          </div>
        </Dialog>
      )}
      {showMktzap && (
        <Helmet
          onChangeClientState={(newState, addedTags, removedTags) => console.log(newState, addedTags, removedTags)}
        >
          <script src="https://paguedireto.mktzap.com.br/webchat/oje90rvfyeroclpifrpc" type="text/javascript" />
        </Helmet>
      )}
      {showSegundaVia && (
        <Dialog
          className="w-[90%] sm:w-[80%] md:w-[70%] lg:w-[50%] xl:w-[45%] h-auto"
          visible
          header={
            mostrarLogo && (
              <img
                className="mx-2"
                src={logoPague}
                alt="direto-logo"
                style={{ minHeight: "30px", maxHeight: "20px", width: "auto" }}
              />
            )
          }
          footer={true}
          onHide={() => setShowSegundaVia(false)}
        >
          <h5 className="text-center">
            <b>Segunda Via do Boleto</b>
          </h5>
          <div className="w-full md:text-left text-center">
            <form
              className="grid w-full"
              onSubmit={(e) => segundaVia(e)}
              // style={{ width: '150%' }}
            >
              <h6 className="mt-2 text-center">Por Favor digite seu e-mail cadastrado.</h6>
              <div className="my-2 text-center">
                {/* <label htmlFor="email">E-mail</label> */}
                <InputText
                  className="w-[80%]"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="ex: seu.email@gmail.com"
                  id="email"
                  type="email"
                />
              </div>
              <div className="flex w-full justify-center">
                <div className="w-1/2 loginButton mt-4">
                  <Button label="Continuar" className="w-full" type="submit" loading={loading} />
                </div>
              </div>
            </form>
          </div>
        </Dialog>
      )}
      {showSelectCredor && (
        <Dialog
          className="w-[85%] sm:w-[75%] md:w-[65%] lg:w-[45%] xl:w-[40%] h-auto"
          visible
          header={
            <img
              className="mx-2"
              src={logoPague}
              alt="direto-logo"
              style={{ minHeight: "30px", maxHeight: "20px", width: "auto" }}
            />
          }
          footer={true}
          onHide={() => setShowSelectCredor(false)}
        >
          <h5 className="text-center">
            <b>Segunda Via do Boleto</b>
          </h5>
          <div className="grid w-full h-full md:text-left text-center justify-evenly">
            <form onSubmit={(e) => segundaViaEnviar(e)}>
              <h6 className="mt-2 text-center">
                <b>Selecione a empresa que gostaria de receber sua segunda via.</b>
              </h6>
              <div className="grid w-full text-center">
                {credorData.map((credor) => (
                  <Button
                    className=""
                    onClick={() => setCredorDocumento(credor.credor_documento)}
                    key={credor.credor_documento}
                    type="submit"
                    style={{
                      background: "#11CC66",
                      borderWidth: 0,
                      marginTop: "1rem",
                      fontWeight: 600,
                      fontSize: 13,
                    }}
                  >
                    {credor.credor_nome}
                  </Button>
                ))}
              </div>
            </form>
          </div>
        </Dialog>
      )}
    </>
  );
}

export default QuickMenu;
